import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FieldPositioningEditPage } from './field-positioning-edit';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    FieldPositioningEditPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(FieldPositioningEditPage),
    TextMaskModule,
    SharedModule,
    FoundationModule,
  ],
})
export class FieldPositioningEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/field-positioning/field-positioning-edit/field-positioning-edit.module.ts